import { useEffect, useState, useContext } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate, useParams } from "react-router-dom";
import {
  createClientIdQueryString,
  createQueryString,
  sendApiRequest,
} from "../../services/Base/base-service";

import UserContext from "../../store/user-context";
import {
  Icon,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Alert,
  Spinner,
} from "design-react-kit";

const ConfirmModal = ({
  confirmModalOpen,
  confirmModalCloseHandler,
  user,
  setUsers,
  setResults,
  notifyUser,
  clientId,
  method,
  text,
  clientDocumentRuleId,
  notificationTargetFieldId,
  setClients,
  setDocuments,
  setExtFlowConfigs,
  setPhrases,
  setDocumentsNumber,
  setPhrasesNumber,
}) => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  const params = useParams();
  const notificationId = params?.id;
  const clientIdparam = params?.clientId;

  const userContext = useContext(UserContext);

  useEffect(() => {
    if (!confirmModalOpen) {
      setError(null);
    }
  }, [confirmModalOpen]);

  const deleteUserHandler = () => {
    setError(null);
    setIsLoading(true);
    if (user !== null) {
      sendApiRequest(
        `User/DeleteUser/${user}`,
        "DELETE",
        true,
        null,
        signIn,
        signOut,
        navigate,
        null,
        userContext
      ).then((response) => {
        if (response !== undefined) {
          if (response.errors !== null) {
            setError(response.errors);
            setIsLoading(false);
          } else {
            setTimeout(() => {
              sendApiRequest(
                "User/GetAllUsers",
                "GET",
                true,
                {
                  fiscalCode: userContext.selectedClientFiscalCode,
                  flowId: null,
                },
                signIn,
                signOut,
                navigate,
                createQueryString,
                userContext
              ).then((response) => {
                if (response !== undefined) {
                  if (response.errors !== null) {
                    setError(response.errors);
                  } else {
                    setUsers(response.data.users);
                    setResults(response.data.users);
                    confirmModalCloseHandler();
                    setIsLoading(false);
                    notifyUser(
                      "Rimozione account utente completata con successo!",
                      "success",
                      "it-check"
                    );
                  }
                }
              });
            }, 500);
          }
        }
      });
    }
  };

  const deleteNotificationHandler = () => {
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      `Notification/DeleteInvalidNotification/${notificationId}`,
      "DELETE",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          notifyUser(
            "Rimozione notifice completata con successo!",
            "success",
            "it-check"
          );
          confirmModalCloseHandler();
          setTimeout(() => {
            navigate(-1);
          }, 2000);
        }
      }
    });
  };

  const excludeNotificationHandler = () => {
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      `Notification/InvalidateNotification`,
      "POST",
      true,
      { notificationId },
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          notifyUser(
            "Notifica esclusa dal flusso con successo!",
            "success",
            "it-check"
          );
          confirmModalCloseHandler();
          setTimeout(() => {
            navigate(-1);
          }, 2000);
        }
      }
    });
  };

  const deleteClientConfigurationHandler = () => {
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      `ClientConfiguration/DeleteClientConfiguration/${clientId}`,
      "DELETE",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          notifyUser(
            "Rimozione typologia servizio configurazione completata con successo!",
            "success",
            "it-check"
          );
          confirmModalCloseHandler();
          setTimeout(() => {
            sendApiRequest(
              "ClientConfiguration/GetClientConfigurations",
              "GET",
              true,
              {
                fiscalCode: userContext.selectedClientFiscalCode,
                flowId: null,
              },
              signIn,
              signOut,
              navigate,
              createQueryString,
              userContext
            ).then((response) => {
              if (response !== undefined) {
                if (response.errors !== null) {
                  setError(response.errors);
                  setIsLoading(false);
                } else {
                  setClients(response.data.clientConfigurations);
                  setIsLoading(false);
                  confirmModalCloseHandler();
                }
              }
            });
          }, 500);
        }
      }
    });
  };

  const deleteExternalFlowConfigurationHandler = () => {
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      `ExternalFlowConfiguration/DeleteExternalFlowConfiguration/${clientId}`,
      "DELETE",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          notifyUser(
            "Rimozione configurazione flussi esterni per la tipologia servizio selezionata completata con successo!",
            "success",
            "it-check"
          );
          confirmModalCloseHandler();
          setTimeout(() => {
            sendApiRequest(
              "ExternalFlowConfiguration/GetExternalFlowConfigurations",
              "GET",
              true,
              {
                fiscalCode: userContext.selectedClientFiscalCode,
                flowId: null,
              },
              signIn,
              signOut,
              navigate,
              createQueryString,
              userContext
            ).then((response) => {
              if (response !== undefined) {
                if (response.errors !== null) {
                  setError(response.errors);
                  setIsLoading(false);
                } else {
                  setExtFlowConfigs(response.data.externalFlowConfigurations);
                  setIsLoading(false);
                }
              }
            });
          }, 500);
        }
      }
    });
  };

  const deleteClientDocumentRuleHandler = () => {
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      `ClientConfiguration/DeleteClientDocumentRule/${clientDocumentRuleId}`,
      "DELETE",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          notifyUser(
            "Rimozione configurazione documento completata con successo!",
            "success",
            "it-check"
          );
          confirmModalCloseHandler();
          setTimeout(() => {
            sendApiRequest(
              "ClientConfiguration/GetClientDocumentRules",
              "GET",
              true,
              { clientId },
              signIn,
              signOut,
              navigate,
              createClientIdQueryString,
              userContext
            ).then((response) => {
              if (response !== undefined) {
                if (response.errors !== null) {
                  setError(response.errors);
                  setIsLoading(false);
                } else {
                  setDocuments(response.data.clientDocumentRules);
                  setIsLoading(false);
                  setTimeout(() => {
                    sendApiRequest(
                      "ClientConfiguration/GetSupportedDocumentTypes",
                      "GET",
                      true,
                      { clientId: clientIdparam },
                      signIn,
                      signOut,
                      navigate,
                      createClientIdQueryString,
                      userContext
                    ).then((response) => {
                      if (response !== undefined) {
                        if (response.errors !== null) {
                          setError(response.errors);
                          setIsLoading(false);
                        } else {
                          setDocumentsNumber(
                            response.data.supportedDocumentTypes.length
                          );
                          setIsLoading(false);
                        }
                      }
                    });
                  }, 500);
                }
              }
            });
          }, 500);
        }
      }
    });
  };

  const deleteClientDocumentFieldConfigHandler = () => {
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      `ClientConfiguration/DeleteClientDocumentFieldConfig`,
      "DELETE",
      true,
      {
        clientDocumentRuleId: clientDocumentRuleId,
        notificationTargetFieldId: notificationTargetFieldId,
      },
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          notifyUser(
            "Rimozione documento (frasi chiave) completata con successo!",
            "success",
            "it-check"
          );
          confirmModalCloseHandler();
          setTimeout(() => {
            sendApiRequest(
              `ClientConfiguration/GetClientDocumentFieldConfigs?clientDocumentRuleId=${clientDocumentRuleId}`,
              "GET",
              true,
              null,
              signIn,
              signOut,
              navigate,
              null,
              userContext
            ).then((response) => {
              if (response !== undefined) {
                if (response.errors !== null) {
                  setError(response.errors);
                  setIsLoading(false);
                } else {
                  setPhrases(response.data.clientDocumentFieldConfigs);
                  setIsLoading(false);
                  setTimeout(() => {
                    sendApiRequest(
                      "ClientConfiguration/GetKeyPhrases",
                      "GET",
                      true,
                      { clientId: clientIdparam },
                      signIn,
                      signOut,
                      navigate,
                      createClientIdQueryString,
                      userContext
                    ).then((response) => {
                      if (response !== undefined) {
                        if (response.errors !== null) {
                          setError(response.errors);
                          setIsLoading(false);
                        } else {
                          setPhrasesNumber(response.data.keyPhrases.length);
                          setIsLoading(false);
                        }
                      }
                    });
                  }, 500);
                }
              }
            });
          }, 500);
        }
      }
    });
  };

  const deleteStagedFlowConfigurationHandler = () => {
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      `StagedFlowConfiguration/DeleteStagedFlowConfiguration/${clientId}`,
      "DELETE",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          notifyUser(
            "Rimozione configurazione flussi esterni per la tipologia servizio selezionata completata con successo!",
            "success",
            "it-check"
          );
          confirmModalCloseHandler();
          setTimeout(() => {
            sendApiRequest(
              "StagedFlowConfiguration/GetStagedFlowConfigurations",
              "GET",
              true,
              {
                fiscalCode: userContext.selectedClientFiscalCode,
                flowId: null,
              },
              signIn,
              signOut,
              navigate,
              createQueryString,
              userContext
            ).then((response) => {
              if (response !== undefined) {
                if (response.errors !== null) {
                  setError(response.errors);
                  setIsLoading(false);
                } else {
                  setExtFlowConfigs(response.data.stagedFlowConfigurations);
                  setIsLoading(false);
                }
              }
            });
          }, 500);
        }
      }
    });
  };

  const deleteMethod = () => {
    if (method === "deleteUserHandler") {
      deleteUserHandler();
    } else if (method === "deleteNotificationHandler") {
      deleteNotificationHandler();
    } else if (method === "deleteClientConfigurationHandler") {
      deleteClientConfigurationHandler();
    } else if (method === "deleteClientDocumentRuleHandler") {
      deleteClientDocumentRuleHandler();
    } else if (method === "deleteClientDocumentFieldConfigHandler") {
      deleteClientDocumentFieldConfigHandler();
    } else if (method === "excludeNotificationHandler") {
      excludeNotificationHandler(method === "deleteClientDocumentRuleHandler");
    } else if (method === "deleteExternalFlowConfigurationHandler") {
      deleteExternalFlowConfigurationHandler();
    } else if (method === "deleteStagedFlowConfigurationHandler") {
      deleteStagedFlowConfigurationHandler();
    }
  };

  return (
    <Modal
      isOpen={confirmModalOpen}
      toggle={confirmModalCloseHandler}
      align="center"
      scrollable
      labelledBy="confirm"
    >
      <ModalHeader toggle={confirmModalCloseHandler} id="confirm"></ModalHeader>
      <ModalBody className="text-center">
        <div className="mb-3">
          <Icon icon="it-info-circle" fill="#D70049" />
          <h5 className="d-inline font-weight-bold ml-2">Attenzione!</h5>
        </div>
        {error !== null && error.length !== undefined && (
          <Alert color="danger">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {isLoading && <Spinner double active />}
        <p className="mb-2 font-weight-normal">{text}</p>
        <p className="font-weight-bold modal-email mb-2"></p>
        <p className="mb-3 font-weight-normal">
          L'azione è irreversibile, vuoi procedere comunque?
        </p>
        <div className="col-sm-12 mb-2 d-flex align-items-center justify-content-around">
          <Button
            color="white"
            className="mr-2"
            onClick={confirmModalCloseHandler}
            id="user-cancel"
          >
            Annulla
          </Button>
          {method !== "excludeNotificationHandler" && (
            <Button color="danger" onClick={(e) => deleteMethod()}>
              Sì, elimina
            </Button>
          )}
          {method === "excludeNotificationHandler" && (
            <Button color="danger" onClick={(e) => deleteMethod()}>
              Sì, escludi
            </Button>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmModal;
